import { Model } from 'pinia-orm';
import moment from "moment";

export default class Booster extends Model {

    static get entity() {
        return 'booster'
    }

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            duration: this.number(0),
            media: this.attr(null),
            icon: this.attr(null),
            active: this.boolean(false),
            price: this.attr(0),
            list_price: this.attr(0),
            title: this.attr(0),
            short_description: this.attr(0),
            description: this.attr(0),
            spotlight: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            sequence: this.number(0),

            expires_at: this.attr(null),
            published_at: this.attr(null),
            requested_at: this.attr(null),
        }
    }

    static createBoosterCampaign(userId, data) {
        return axios.post(route('api.manage.companies.booster.create-booster-campaign', {userId: userId}), data).then(res => res.data);
    }
}
